<template>
  <a-card>
    <a-alert class="m-b-10" type="info" show-icon
      message="生码配置说明"
      description="每个品牌商一套独立生码配置；一旦该品牌商产生已完成的生码单，配置即固化不可再修改。数字乱码密钥（random_key）由系统在首次生码时自动生成并永久保持不变，无需也不可在此填写。" />
    <a-form layout='inline' class="m-b-15">
      <a-form-item label="品牌商">
        <a-select v-model:value="brandId" show-search option-filter-prop="label" :style="{width:'300px'}" placeholder="请选择品牌商" @change="brandChange">
          <a-select-option v-for="item in brands" :key="item.brand_no" :value="item.brand_no" :label="item.company + '(' + item.brand_no + ')'">{{item.company}}({{item.brand_no}})</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <a-spin :spinning="configLoading">
      <template v-if="brandId">
        <a-alert v-if="isFixed == 1" class="m-b-10" type="warning" show-icon message="该品牌商已有完成的生码单，配置已固化，不可修改" />
        <a-form :model="form" :label-col="{span:24}" :wrapper-col="{span:24}" style="max-width:1200px">
          <a-row :gutter="24">
            <!-- 大标配置 -->
            <a-col :span="8">
              <a-card size="small" title="大标配置" :bordered="true">
                <a-form-item label="类型">
                  <a-select v-model:value="form.big_type" :disabled="isFixed == 1">
                    <a-select-option v-for="item in bigTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="码长度">
                  <a-input-number v-model:value="form.big_length" :min="4" :max="18" :disabled="isFixed == 1" style="width:100%" />
                </a-form-item>
                <a-form-item label="自定义起始值">
                  <a-space direction="vertical" style="width:100%">
                    <a-switch v-model:checked="form.big_diy_status" :checkedValue="1" :unCheckedValue="0" :disabled="isFixed == 1" />
                    <a-input-number v-if="form.big_diy_status == 1" v-model:value="form.big_diy_value" :min="0" :disabled="isFixed == 1" style="width:100%" placeholder="起始流水号值" />
                  </a-space>
                </a-form-item>
              </a-card>
            </a-col>
            <!-- 中标配置 -->
            <a-col :span="8">
              <a-card size="small" title="中标配置" :bordered="true">
                <a-form-item label="类型">
                  <a-select v-model:value="form.middle_type" :disabled="isFixed == 1">
                    <a-select-option v-for="item in bigTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="码长度">
                  <a-input-number v-model:value="form.middle_length" :min="4" :max="18" :disabled="isFixed == 1" style="width:100%" />
                </a-form-item>
                <a-form-item label="自定义起始值">
                  <a-space direction="vertical" style="width:100%">
                    <a-switch v-model:checked="form.middle_diy_status" :checkedValue="1" :unCheckedValue="0" :disabled="isFixed == 1" />
                    <a-input-number v-if="form.middle_diy_status == 1" v-model:value="form.middle_diy_value" :min="0" :disabled="isFixed == 1" style="width:100%" placeholder="起始流水号值" />
                  </a-space>
                </a-form-item>
              </a-card>
            </a-col>
            <!-- 小标配置 -->
            <a-col :span="8">
              <a-card size="small" title="小标配置" :bordered="true">
                <a-form-item label="类型" help="仅支持数字乱码、流水号">
                  <a-select v-model:value="form.small_type" :disabled="isFixed == 1">
                    <a-select-option v-for="item in smallTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="码长度">
                  <a-input-number v-model:value="form.small_length" :min="4" :max="18" :disabled="isFixed == 1" style="width:100%" />
                </a-form-item>
                <a-form-item label="自定义起始值">
                  <a-space direction="vertical" style="width:100%">
                    <a-switch v-model:checked="form.small_diy_status" :checkedValue="1" :unCheckedValue="0" :disabled="isFixed == 1" />
                    <a-input-number v-if="form.small_diy_status == 1" v-model:value="form.small_diy_value" :min="0" :disabled="isFixed == 1" style="width:100%" placeholder="起始流水号值" />
                  </a-space>
                </a-form-item>
              </a-card>
            </a-col>
          </a-row>
          <a-form-item style="margin-top:24px">
            <a-button type="primary" :loading="saveLoading" :disabled="isFixed == 1" v-has:genCodeConfigSave="saveConfig">保存配置</a-button>
          </a-form-item>
        </a-form>
      </template>
      <a-empty v-else description="请先选择品牌商" />
    </a-spin>
  </a-card>
</template>
<script>
import { onMounted, reactive, ref } from "vue";
import { getGenConfig, saveGenConfig } from "@/api/codeGen";
import { getBrandtList } from "@/api/brand";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";

// 后端 CONFIG_FIELDS 白名单
const configFields = [
  "big_type", "big_length", "big_diy_status", "big_diy_value",
  "middle_type", "middle_length", "middle_diy_status", "middle_diy_value",
  "small_type", "small_length", "small_diy_status", "small_diy_value",
];
const defForm = {
  big_type: 2,
  big_length: 8,
  big_diy_status: 0,
  big_diy_value: 0,
  middle_type: 2,
  middle_length: 9,
  middle_diy_status: 0,
  middle_diy_value: 0,
  small_type: 2,
  small_length: 10,
  small_diy_status: 0,
  small_diy_value: 0,
};
export default {
  setup() {
    const bigTypes = [
      { value: 1, label: "数字乱码" },
      { value: 2, label: "流水号" },
    ];
    const smallTypes = [
      { value: 1, label: "数字乱码" },
      { value: 2, label: "流水号" },
    ];
    // 品牌商下拉
    const brands = ref([]);
    const brandId = ref(undefined);
    const initBrands = async () => {
      let res = await getBrandtList({ page: 1, limit: 1000 }).then((res) => res.data).catch((error) => error);
      if ($iscode(res)) {
        brands.value = res.data.data || [];
      }
    };
    onMounted(() => {
      initBrands();
    });
    // 配置读取
    const form = reactive({ ...defForm });
    const isFixed = ref(0);
    const configLoading = ref(false);
    const brandChange = async (value) => {
      if (!value) return;
      configLoading.value = true;
      let res = await getGenConfig(value).then((res) => res.data).catch((error) => error);
      configLoading.value = false;
      if ($iscode(res)) {
        // 仅回填白名单字段（后端返回不含 random_key）
        configFields.forEach((field) => {
          if (res.data[field] !== undefined && res.data[field] !== null) {
            form[field] = Number(res.data[field]);
          }
        });
        isFixed.value = Number(res.data.is_fixed || 0);
      } else {
        message.error(res.msg);
      }
    };
    // 保存配置
    const saveLoading = ref(false);
    const saveConfig = async () => {
      if (!brandId.value) {
        message.error("请先选择品牌商");
        return;
      }
      let data = {};
      configFields.forEach((field) => {
        data[field] = form[field];
      });
      const hide = message.loading("正在保存...", 0);
      saveLoading.value = true;
      let res = await saveGenConfig({ brand_id: brandId.value, data }).then((res) => res.data).catch((error) => error);
      saveLoading.value = false;
      setTimeout(hide, 100);
      // 失败时展示后端 msg（如配置已固化）
      $iscode(res, true);
    };
    return {
      bigTypes,
      smallTypes,
      brands,
      brandId,
      brandChange,
      form,
      isFixed,
      configLoading,
      saveLoading,
      saveConfig,
    };
  },
};
</script>
